import React from 'react';
const hasMultipleProviders = (providers) => Array.isArray(providers) &&
    providers.length > 0 &&
    Array.isArray(providers[0]);
export const withProviders = (providers) => (WrappedComponent) => (wrappedComponentProps) => (hasMultipleProviders(providers) ? providers : [providers]).reduceRight((accumulator, currentProvider) => {
    if (currentProvider.length === 0) {
        return accumulator;
    }
    const [Provider, providerProps] = currentProvider;
    return React.createElement(Provider, { ...providerProps }, accumulator);
}, React.createElement(WrappedComponent, { ...wrappedComponentProps }));
